// This is an auto-generated file. Do not modify directly.

import Locale from '@helios/shared/types/locale'

export type LocaleCode =
    | 'en-gb'
    | 'da-dk'
    | 'de-de'
    | 'es-es'
    | 'sv-se'
    | 'en-ie'
    | 'fi-fi'
    | 'de-at'
    | 'fr-be'
    | 'nl-be'
    | 'fr-fr'
    | 'nl-nl'
    | 'et-ee'
    | 'it-it'
    | 'pt-pt'
    | 'en-lu'
    | 'no-no'
export type UrlCode =
    | 'en'
    | 'da'
    | 'de'
    | 'es'
    | 'se'
    | 'ie'
    | 'fi'
    | 'at'
    | 'fr-be'
    | 'nl-be'
    | 'fr'
    | 'nl'
    | 'ee'
    | 'it'
    | 'pt'
    | 'lu'
    | 'no'
export type CountryCode =
    | 'gb'
    | 'dk'
    | 'de'
    | 'es'
    | 'se'
    | 'ie'
    | 'fi'
    | 'at'
    | 'be'
    | 'fr'
    | 'nl'
    | 'ee'
    | 'it'
    | 'pt'
    | 'lu'
    | 'no'
export type LanguageCode = 'en' | 'da' | 'de' | 'es' | 'sv' | 'fi' | 'fr' | 'nl' | 'it' | 'pt'

const locales: Locale[] = [
    {
        code: 'en-gb',
        urlCode: 'en',
        country: 'gb',
        countryName: 'United Kingdom',
        language: 'en',
        languageName: 'English',
        default: true,
        isPreLaunch: false,
    },
    {
        code: 'da-dk',
        urlCode: 'da',
        country: 'dk',
        countryName: 'Danmark',
        language: 'da',
        languageName: 'Dansk',
        default: false,
        isPreLaunch: false,
    },
    {
        code: 'de-de',
        urlCode: 'de',
        country: 'de',
        countryName: 'Deutschland',
        language: 'de',
        languageName: 'Deutsch',
        default: false,
        isPreLaunch: false,
    },
    {
        code: 'es-es',
        urlCode: 'es',
        country: 'es',
        countryName: 'España',
        language: 'es',
        languageName: 'Español',
        default: false,
        isPreLaunch: false,
    },
    {
        code: 'sv-se',
        urlCode: 'se',
        country: 'se',
        countryName: 'Sverige',
        language: 'sv',
        languageName: 'Svenska',
        default: false,
        isPreLaunch: false,
    },
    {
        code: 'en-ie',
        urlCode: 'ie',
        country: 'ie',
        countryName: 'Ireland',
        language: 'en',
        languageName: 'English',
        default: false,
        isPreLaunch: false,
    },
    {
        code: 'fi-fi',
        urlCode: 'fi',
        country: 'fi',
        countryName: 'Suomi',
        language: 'fi',
        languageName: 'Suomi',
        default: false,
        isPreLaunch: false,
    },
    {
        code: 'de-at',
        urlCode: 'at',
        country: 'at',
        countryName: 'Österreich',
        language: 'de',
        languageName: 'Deutsch',
        default: false,
        isPreLaunch: false,
    },
    {
        code: 'fr-be',
        urlCode: 'fr-be',
        country: 'be',
        countryName: 'Belgique',
        language: 'fr',
        languageName: 'Français',
        default: false,
        isPreLaunch: false,
    },
    {
        code: 'nl-be',
        urlCode: 'nl-be',
        country: 'be',
        countryName: 'België',
        language: 'nl',
        languageName: 'Nederlands',
        default: false,
        isPreLaunch: false,
    },
    {
        code: 'fr-fr',
        urlCode: 'fr',
        country: 'fr',
        countryName: 'France',
        language: 'fr',
        languageName: 'Français',
        default: false,
        isPreLaunch: false,
    },
    {
        code: 'nl-nl',
        urlCode: 'nl',
        country: 'nl',
        countryName: 'Nederland',
        language: 'nl',
        languageName: 'Nederlands',
        default: false,
        isPreLaunch: false,
    },
    {
        code: 'et-ee',
        urlCode: 'ee',
        country: 'ee',
        countryName: 'Eesti',
        language: 'en',
        languageName: 'English',
        default: false,
        isPreLaunch: false,
    },
    {
        code: 'it-it',
        urlCode: 'it',
        country: 'it',
        countryName: 'Italia',
        language: 'it',
        languageName: 'Italiano',
        default: false,
        isPreLaunch: false,
    },
    {
        code: 'pt-pt',
        urlCode: 'pt',
        country: 'pt',
        countryName: 'Portugal',
        language: 'pt',
        languageName: 'Português',
        default: false,
        isPreLaunch: false,
    },
    {
        code: 'en-lu',
        urlCode: 'lu',
        country: 'lu',
        countryName: 'Luxembourg',
        language: 'en',
        languageName: 'English',
        default: false,
        isPreLaunch: false,
    },
    {
        code: 'no-no',
        urlCode: 'no',
        country: 'no',
        countryName: 'Norge',
        language: 'en',
        languageName: 'English',
        default: false,
        isPreLaunch: true,
    },
]

export default locales
